import { render, staticRenderFns } from "./TopContributors.vue?vue&type=template&id=447c4e94&scoped=true"
import script from "./TopContributors.vue?vue&type=script&lang=js"
export * from "./TopContributors.vue?vue&type=script&lang=js"
import style0 from "./TopContributors.vue?vue&type=style&index=0&id=447c4e94&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447c4e94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('447c4e94')) {
      api.createRecord('447c4e94', component.options)
    } else {
      api.reload('447c4e94', component.options)
    }
    module.hot.accept("./TopContributors.vue?vue&type=template&id=447c4e94&scoped=true", function () {
      api.rerender('447c4e94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/pages/home/components/TopContributors.vue"
export default component.exports